import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Building2, Sparkles, SprayCan, TreeDeciduous } from "lucide-react";
import { Button } from "@/components/ui/button";

import haldusteenusImg from "@/assets/service-haldusteenus-new.jpg";
import hoolduskoristusImg from "@/assets/service-hoolduskoristus-new.jpg";
import eripuhastusImg from "@/assets/service-eripuhastus-new.jpg";
import muruImg from "@/assets/service-muru-new.jpg";

const services = [
  {
    icon: Building2,
    title: "Haldusteenused",
    description: "Kinnisvarahaldus on protsess, mis tagab hoonete ja territooriumide korrashoiu, väärtuse säilimise ning kasutajate heaolu. Korraldame ühistu koosolekuid, suhtleme elanikega ja haldame dokumente.",
    image: haldusteenusImg,
  },
  {
    icon: Sparkles,
    title: "Hoolduskoristus",
    description: "Puhtus ja korrashoid on oluline nii hoone elanike kui ka külastajate jaoks. Pakume regulaarset trepikodade ja üldkasutatavate ruumide koristust.",
    image: hoolduskoristusImg,
  },
  {
    icon: SprayCan,
    title: "Eripuhastustööd",
    description: "Pakume eripuhastustöid, mis vajavad spetsialiseeritud oskusi ja vahendeid – fassaadipesu, grafitieemaldus, suurpuhastused ja ehitusjärgne koristus.",
    image: eripuhastusImg,
  },
  {
    icon: TreeDeciduous,
    title: "Muru niitmine",
    description: "Professionaalne muruhooldus ja aiahooldus. Regulaarne muru niitmine, trimmimine ning haljasalade korrashoid tagab teie territooriumi ilu.",
    image: muruImg,
  },
];

const ServicesSection = () => {
  const [showAll, setShowAll] = useState(false);
  
  const visibleServices = showAll ? services : services.slice(0, 3);

  return (
    <section id="services" className="py-24 bg-background">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-foreground">
            Meie teenused
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          <AnimatePresence>
            {visibleServices.map((service, index) => (
              <motion.div
                key={service.title}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="group"
              >
                <div className="bg-card rounded-2xl overflow-hidden shadow-card hover:shadow-glow transition-all duration-500 h-full border border-border/50 hover:border-primary/20">
                  <div className="relative h-48 overflow-hidden">
                    <img 
                      src={service.image} 
                      alt={service.title}
                      loading="lazy"
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-card/80 to-transparent" />
                    <div className="absolute bottom-4 left-4 w-12 h-12 rounded-xl bg-primary/90 flex items-center justify-center">
                      <service.icon className="w-6 h-6 text-primary-foreground" />
                    </div>
                  </div>
                  <div className="p-6">
                    <h3 className="text-xl font-bold text-foreground mb-3 font-serif">
                      {service.title}
                    </h3>
                    <p className="text-muted-foreground leading-relaxed">
                      {service.description}
                    </p>
                  </div>
                </div>
              </motion.div>
            ))}
          </AnimatePresence>
        </div>

        {!showAll && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.3 }}
            className="text-center mt-12"
          >
            <Button 
              onClick={() => setShowAll(true)}
              size="lg"
              className="px-8"
            >
              Vaata kõiki teenuseid
            </Button>
          </motion.div>
        )}
      </div>
    </section>
  );
};

export default ServicesSection;
